/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MapPropertyItemDto } from './MapPropertyItemDto';
import {
    MapPropertyItemDtoFromJSON,
    MapPropertyItemDtoFromJSONTyped,
    MapPropertyItemDtoToJSON,
    MapPropertyItemDtoToJSONTyped,
} from './MapPropertyItemDto';

/**
 * 
 * @export
 * @interface FindMapListingsResponse
 */
export interface FindMapListingsResponse {
    /**
     * Array of map property listings
     * @type {Array<MapPropertyItemDto>}
     * @memberof FindMapListingsResponse
     */
    items: Array<MapPropertyItemDto>;
    /**
     * Pagination and other metadata
     * @type {{ [key: string]: any; }}
     * @memberof FindMapListingsResponse
     */
    meta: { [key: string]: any; };
    /**
     * Territory best match information
     * @type {object}
     * @memberof FindMapListingsResponse
     */
    territoryBestMatch?: object;
    /**
     * Method used to match the territory address
     * @type {string}
     * @memberof FindMapListingsResponse
     */
    addressMatchingMethod?: string;
}

/**
 * Check if a given object implements the FindMapListingsResponse interface.
 */
export function instanceOfFindMapListingsResponse(value: object): value is FindMapListingsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function FindMapListingsResponseFromJSON(json: any): FindMapListingsResponse {
    return FindMapListingsResponseFromJSONTyped(json, false);
}

export function FindMapListingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindMapListingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(MapPropertyItemDtoFromJSON)),
        'meta': json['meta'],
        'territoryBestMatch': json['territoryBestMatch'] == null ? undefined : json['territoryBestMatch'],
        'addressMatchingMethod': json['addressMatchingMethod'] == null ? undefined : json['addressMatchingMethod'],
    };
}

export function FindMapListingsResponseToJSON(json: any): FindMapListingsResponse {
    return FindMapListingsResponseToJSONTyped(json, false);
}

export function FindMapListingsResponseToJSONTyped(value?: FindMapListingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(MapPropertyItemDtoToJSON)),
        'meta': value['meta'],
        'territoryBestMatch': value['territoryBestMatch'],
        'addressMatchingMethod': value['addressMatchingMethod'],
    };
}

